<template>
  <vs-popup :active.sync="isActive" id="recipeReviewer" v-esc="escape">
    <vs-row vs-type="flex" vs-w="12" v-if="recipe" class="px-4">
      <vs-row vs-type="flex" vs-w="12">
        <vs-col v-if="recipe.products && recipe.products.length > 0" vs-type="flex" vs-w="4" class="pr-6">
          <img :src="$baseUrl + '/' + recipe.products[0].image" alt="img" class="responsive">
        </vs-col>
        <vs-col v-else-if="recipe.image" vs-type="flex" vs-w="4" class="pr-6">
          <img :src="$baseUrl + '/' + recipe.image" alt="img" class="responsive">
        </vs-col>
        <vs-col vs-type="block" vs-w="8">
          <vs-row vs-type="flex" vs-w="12" class="mt-5">
            <span class="w-full bold text-primary text-medium-small2">
              <span>
                {{recipe.name}}
              </span>
            </span>
            <span class="w-full py-2 italic text-smaller" style="min-height: 10px;">
              {{recipe.description}}
            </span>
          </vs-row>
          <vs-row v-if="recipe.productExtras.length > 0" vs-type="flex" vs-w="w">
            <span class="w-full bold text-medium-small">
              Eklenebilir Ekstralar
            </span>
            <div class="w-auto mt-2">
              <vs-chip v-for="extra in recipe.productExtras" :key="extra.id" variant="secondary" class="recipeExtraChip panel-action-box-shadow mr-2 bold">
                {{ extra.name }}
              </vs-chip>
            </div>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-4">
        <span class="w-full bold text-medium-small">
          Reçete
        </span>
        <vs-table :data="recipe.recipeSteps" class="w-full mt-4" v-if="recipe.recipeSteps.length > 0">
          <template slot="thead">
            <vs-th :class="hasRecipeCostPermission ? 'w-2/12' : 'w-3/12'"><span class="bold text-primary text-smaller">Stok Kodu</span></vs-th>
            <vs-th :class="hasRecipeCostPermission ? 'w-4/12' : 'w-5/12'"><span class="bold text-primary text-smaller">Stok Adı</span></vs-th>
            <vs-th v-if="hasRecipeCostPermission" class="w-2/12"><span class="bold text-primary text-smaller text-center">Birim Maliyeti</span></vs-th>
            <vs-th :class="hasRecipeCostPermission ? 'w-2/12' : 'w-4/12'"><span class="bold text-primary text-smaller text-center">Miktar</span></vs-th>
            <vs-th v-if="hasRecipeCostPermission" class="w-2/12"><span class="bold text-primary text-smaller text-center">Toplam Maliyet</span></vs-th>
          </template>
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr v-for="step in data" :key="step.id">
                <vs-td :class="hasRecipeCostPermission ? 'w-2/12' : 'w-3/12'">
                  <p class="text-xsmall font-medium">{{ step.rawMaterial.stockCode || '-' }}</p>
                </vs-td>
                <vs-td :class="hasRecipeCostPermission ? 'w-4/12' : 'w-5/12'">
                  <p class="text-xsmall font-medium">{{ step.rawMaterial.name }}</p>
                </vs-td>
                <vs-td v-if="hasRecipeCostPermission" class="w-2/12 text-center">
                  <p class="text-xsmall font-medium">{{ $toCurrency(step.rawMaterial.buyPrice) }}</p>
                </vs-td>
                <vs-td :class="hasRecipeCostPermission ? 'w-2/12 text-center' : 'w-4/12 text-center'">
                  <p class="text-xsmall font-medium">{{ step.unitPartQuantity }} {{ step.rawMaterial.unit.name }}</p>
                </vs-td>
                <vs-td v-if="hasRecipeCostPermission" class="w-2/12 text-center">
                  <p class="text-xsmall font-medium bold text-primary">
                    {{ $toCurrency(step.rawMaterial.buyPrice * step.unitPartQuantity) }}
                  </p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </vs-row>
      <vs-row v-if="hasRecipeCostPermission && recipe.totalBuyPrice && recipe.totalBuyPrice > 0" vs-type="flex" vs-w="12" class="mt-2">
        <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end">
           <span class="text-small weight-500">
          Toplam Maaliyet
        </span>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end">
          <span class="bold text-small text-primary">
            {{ $toCurrency(recipe.manuelTotalBuyPrice) }}
          </span>
        </vs-row>
      </vs-row>
    </vs-row>
  </vs-popup>
</template>
<script>
import { isGranted } from "@/utils/auth";
import PermissionTypes from "@/model/constants/permissionTypes";

export default {
  name: "RecipeReviewer",
  data() {
    return {
      isActive: false,
      recipe: null,
      selectedRecipeId: null
    }
  },
  computed: {
    hasRecipeCostPermission() {
      return (
        isGranted("receipt_cost_read") ||
        isGranted("hot_sale_recipe_cost_read") ||
        isGranted(PermissionTypes.hot_sale_recipe_cost_read) ||
        isGranted("Sıcak Satış-Reçete Maliyetini Görüntüleme") ||
        isGranted("Reçete Maliyetini Görüntüleme")
      );
    }
  },
  methods: {
    escape() {
      if (this.isActive) {
        this.isActive = false
      }
    },
    fetchRecipe() {

    }
  },
  watch: {
    isActive(val) {
      if (!val) {
        this.$emit("closed")
      } else if(this.selectedRecipeId) {

      }
    }
  }
}
</script>

<style>
#recipeReviewer .vs-popup .vs-popup--header {
  background: unset !important;
  border-radius: 7px 7px 0 0;
}
#recipeReviewer .vs-popup {
  width: 1000px!important;
  color: #2B2B2B;
}
#recipeReviewer .vs-popup--title {
  display: none;
}
#recipeReviewer .vs-popup--close {
  position: absolute;
  right: 0;
  top: 0;
}
#recipeReviewer .recipeExtraChip {
  background-color: rgba(210, 196, 189, 0.5);
  border-radius: 4px;
  margin-bottom: .5rem;
  padding: 4px 16px!important;
}
#recipeReviewer .recipeExtraChip .vs-chip--text {
  margin-left: 0!important;
}
</style>
